import { sanitizeHtmlString } from './pds-xss';

let registeredComponents = new Map<string, any>();

export let pdsAccessibility = {

  /**
   * calls the announceText function in pdsAnnounce.ts
   * @param text - string of text to announce
   * @param id - the id of the container to read from, unspecified id will be read from the default container.
   */
  announceViaScreenReader: function(text: string, id = 'default'): void {
    if (!(text.trim() === '' || text == null)) {
      let sanitizedText = sanitizeHtmlString(text);
      let myElement = registeredComponents.get(id);
      if (myElement != null) {
        myElement.announceText(sanitizedText);
      }
    }
  },

  /**
   * registers a pds component with an id (optional)
   * If no ID given, it will register your component as default: key: 'default'
   *
   * @param component - any component that you want to register
   * @param id - optional id to add, if no id's exist in map it will add an id as default
   */

  registerAnnounceTextComponent: function(component: any, id?: string): void {
    if (id) {
      registeredComponents.set(id, component);
    } else {
      registeredComponents.set('default', component);
    }
  },

  /**
   * this function unregisters a component...
   * if no id is given,
   * it unregisteres the default component
   * @param componentToDelete
   */

  unregisterAnnounceTextComponent: function(id = 'default'): void {
    if (registeredComponents.get(id) != null) {
      registeredComponents.delete(id);
    }
  },

  /**
   * This function returns a list of registered components that were registered under default.
   */

  removeAnnounceTextComponentFromDefault: function():  void {
    if (registeredComponents.get('default') != null) {
      registeredComponents.delete('default');
    }
  },

  /**
   * gets the registered components
   * @returns a map of registered components.
   */

  getListOfRegisteredComponent:  function(): Map<string, any> {
    return registeredComponents;
  }
};
